__turbopack_context__.v({
  "word": "ScrollRevealText-module__YYEu3G__word",
  "wrapper": "ScrollRevealText-module__YYEu3G__wrapper",
});
